import { c as __assign } from './tslib.es6-71ded574.js';
import React__default from 'react';
import { U as UltimateSpecialOffers } from './UltimateSpecialOffers-71d76709.js';

var SpecialOffers = function (props) {
    return React__default.createElement(UltimateSpecialOffers, __assign({}, props));
};

export { SpecialOffers as S };
//# sourceMappingURL=SpecialOffers-1caa49fb.js.map
